export default __webpack_public_path__ + "static/media/band-pepe.ed1a8852.gif";